import { useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { AmountFormatted } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'

import { reatomInstantTradeBalance } from '../../atoms/reatom-instant-trade-usd-balance'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const InstantTradeSellBalance: React.FC<Props> = ({
  pair,
  className,
}) => {
  const { t } = useTranslation()
  const usdBalanceAtom = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomInstantTradeBalance({ swapDirection: 'sell', pair }),
    [pair],
  )
  const [balanceInUsd] = useAtom(usdBalanceAtom)

  return (
    <Root className={className}>
      {t('common.bal')}:{' '}
      <Balance>
        <AmountFormatted
          amount={balanceInUsd}
          currency="$"
          roundingMode="trunc"
        />
      </Balance>
    </Root>
  )
}

const Root = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: var(--text-11);
  white-space: nowrap;
`

const Balance = styled.span`
  color: var(--appearance-inv-1);
`
